﻿import { GuiDetailGeneric } from "../../GuiDetailGeneric";
export class GuiDetailAuftragnehmer extends GuiDetailGeneric {
    constructor() {
        super("Auftragnehmer");
    }
}
